import React, {
  useState,
  useEffect,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import Modal from '../../../../../../../../components/v2/Modal';
import InputLabel from '../../../../../../../../components/v2/InputLabel';
import { PrimaryButton } from '../../../../../../../../components/Button/ActionButtons';
import { fieldName } from '../../formFields';
import {
  ActionButtonsContainer,
  StyledRepeatCountInput,
} from './styles';
import texts from './texts';

const MIN_REPEAT_COUNT = 1;
const MAX_REPEAT_COUNT = 52;

const WorkoutDaysRepeater = ({
  open,
  onClose,
}) => {
  const [repeatCount, setRepeatCount] = useState(MIN_REPEAT_COUNT);
  const { values, setFieldValue } = useFormikContext();

  const workoutDaysList = values[fieldName.WORKOUT_DAYS];

  useEffect(() => {
    if (open) {
      setRepeatCount(MIN_REPEAT_COUNT);
    }
  }, [open]);

  const onRepeatCountChange = useCallback((event) => {
    const parsedValue = parseInt(event.target.value, 10);
    if (Number.isNaN(parsedValue)) {
      setRepeatCount(MIN_REPEAT_COUNT);
      return;
    }

    const boundedValue = Math.min(Math.max(parsedValue, MIN_REPEAT_COUNT), MAX_REPEAT_COUNT);
    setRepeatCount(boundedValue);
  }, []);

  const onRepeatWorkoutDays = useCallback(() => {
    const repeatedWorkoutDays = [];

    for (let i = 0; i < repeatCount; i += 1) {
      workoutDaysList.forEach((day) => {
        repeatedWorkoutDays.push({ ...day });
      });
    }

    setFieldValue(fieldName.WORKOUT_DAYS, [...workoutDaysList, ...repeatedWorkoutDays]);
    onClose();
  }, [
    onClose,
    repeatCount,
    setFieldValue,
    workoutDaysList,
  ]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={texts.modalTitle}
      description={texts.modalDescription}
      actionButtons={(
        <ActionButtonsContainer>
          <PrimaryButton
            onClick={onClose}
            variant="dimmed"
            size="large"
          >
            {texts.cancel}
          </PrimaryButton>
          <PrimaryButton
            onClick={onRepeatWorkoutDays}
            variant="light"
            size="large"
          >
            {texts.repeat}
          </PrimaryButton>
        </ActionButtonsContainer>
      )}
    >
      <InputLabel>{texts.repeatCountLabel}</InputLabel>
      <StyledRepeatCountInput
        type="number"
        value={repeatCount}
        onChange={onRepeatCountChange}
        inputProps={{
          min: MIN_REPEAT_COUNT,
          max: MAX_REPEAT_COUNT,
        }}
      />
    </Modal>
  );
};

WorkoutDaysRepeater.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WorkoutDaysRepeater;
